import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { DummyProducts } from "../../helpers";
import { NavLink, Link } from "react-router-dom";
import { Navbar } from "../../components";
import { Footer } from "../../components";
import classes from "./Cart.module.css";
import { Helmet } from "react-helmet";
import { ModalComponent } from "./Modal";
import { Button, Modal } from "react-bootstrap";

const Cart = (props) => {
  const { t, i18n } = useTranslation();
  const [modalCartToggle, setModalCartToggle] = useState(false);
  const [selectedQt, setSelectedQt] = useState();
  const [qunatity, setQunatity] = useState([
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 7, label: 7 },
  ]);
  const quantityHandler = (e) => {
    console.log("Selected Value Is: " + e.value);
    setSelectedQt(e.value);
  };
  const hiddenModalHandler = () => {
    setModalCartToggle(false);
  };
  return (
    <div className={`wrapper-container ${classes.wrapperContainer}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Cart</title>
        <body className="dynamic-class-for-body-on-this-view" />
      </Helmet>
      <Navbar />
      <ModalComponent
        show={modalCartToggle}
        onHide={() => setModalCartToggle(false)}
      />
      <div className={classes.cartContainer}>
        <div className={`container`}>
          <div className={classes.cartContent}>
            <div className={classes.cartTitle}>Cart (2)</div>
            <div className={`row`}>
              <div className={`col-lg-8`}>
                <div className={classes.cartOrders}>
                  <div className={classes.cartOrderRow}>
                    <div className={classes.cartOrderContent}>
                      <div className={classes.cartRowView}>
                        <img
                          src={
                            "https://image.freepik.com/free-photo/kebab-platter-with-lamb-chicken-lula-tikka-kebabs-grilled-vegetables-with-red-onion-salad_141793-2251.jpg"
                          }
                          className={`img-fluid`}
                        />
                      </div>
                      <div className={classes.cartRowDetails}>
                        <div className={classes.cartDetailsTitle}>
                          Chicken Winger
                        </div>
                        <div className={classes.cartDetailsDescription}>
                          Lorem Ipsum is simply dummy text of the printing and
                          typesetting industry. Lorem Ipsum
                        </div>
                        <div className={classes.cartDetailsPrice}>
                          <span>Price </span>
                          <span className={classes.spanPrice}>100 EGP</span>
                          <sub className={`ml-1 mr-1`}>(Per One)</sub>
                        </div>
                        <div className={classes.productQuantity}>
                          <div className={classes.quantityText}>Quantity: </div>
                          <Select
                            styles={{
                              width: "110px",
                            }}
                            className={classes.quantitySelect}
                            options={qunatity}
                            defaultValue={{ value: 3, label: 3 }}
                            onChange={quantityHandler}
                            placeholder={"Qy..."}
                          />
                        </div>
                        <div className={classes.productTotalQP}>
                          <div>
                            <span>*Qty Selected </span>
                            <span className={classes.qp}>{selectedQt}</span>
                            <span> and Total Price </span>
                            <span className={classes.qp}>({100} EGP)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={classes.deleteCartProduct}>
                      <button className={classes.deleteProductBtn}>
                        <span
                          className={`icon-trash ${classes.trashCart}`}
                        ></span>
                        <span className={`ml-1 mr-1`}>Delete</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`col-lg-4`}>
                <div className={classes.cartCalTotalPrice}>
                  <div className={classes.cartPriceTitle}>
                    <span className={classes.cptText}>Items (1)</span>
                    <span className={classes.cptPrice}>400</span>
                  </div>
                  <div className={classes.cartPriceTitle}>
                    <span className={classes.cptText}>Delivery</span>
                    <span className={classes.cptPrice}>20</span>
                  </div>
                  <div className={classes.couponCompleted}>
                    <div className={classes.couponCheck}>
                      <span
                        className={`icon-check ${classes.iconCheck}`}
                      ></span>{" "}
                      Coupon will save
                    </div>
                    <span className={classes.cptPrice}>- 20</span>
                  </div>
                  <div className={classes.cartTotalPrice}>
                    <div className={classes.cartPriceTitle}>
                      <span className={classes.cptText}>Total Price</span>
                      <span className={classes.cptPrice}>100 EGP</span>
                    </div>
                  </div>
                  <div className={classes.checkoutContainer}>
                    <button
                      onClick={() => setModalCartToggle(true)}
                      className={`main-button ${classes.checkoutBtn}`}
                    >
                      Checkout Order
                    </button>
                  </div>
                  <div className={classes.couponContainer}>
                    <input
                      className={classes.couponValue}
                      type="text"
                      placeholder={"Enter Coupon Code"}
                    />
                    <button className={`main-button ${classes.couponBtn}`}>
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export { Cart };
